module.exports = __webpack_public_path__ + "img/2021-11-04.536647ab.jpg";